export default __webpack_public_path__ + "media/flags/tz-976dcabc.svg";